<template>
  <div class="page">
    <!-- 统一风格页头 -->
    <div class="page-header">
      <div class="header-left">
        <h1 class="page-title">老師激活學生統計</h1>
        <p class="page-subtitle">按老師查看各年級學生激活數量統計</p>
      </div>
      <div class="header-right">
        <!-- 可扩展添加导出/刷新等按钮 -->
      </div>
    </div>

    <div class="layout">
      <!-- 搜索筛选区 -->
      <div class="search-card">
        <div class="search-row">
          <div class="search-item">
            <el-select
                size="small"
                @change="getGradeStudentCountByTeacher"
                v-model="formLabelAlign.branchSchoolId"
                placeholder="請選擇分校"
                filterable
                ref="branchSchoolSelect"
                :filter-method="filterBranchSchool"
                clearable
                style="width: 100%;"
            >
              <el-option
                  v-for="(item) in filteredBranchSchools"
                  :key="item.id"
                  :label="`${item.abbreviation || ''}${item.nameZh || ''}`"
                  :value="item.id"
                  :title="`${item.abbreviation || ''}${item.nameZh || ''}`"
              ></el-option>
            </el-select>
          </div>
          <div class="search-item">
            <el-autocomplete
                popper-class="my-autocomplete"
                v-model="formLabelAlign.tagsLike"
                :fetch-suggestions="querySearch"
                placeholder="請輸入老師標籤"
                @select="handleSelect"
                size="small"
                clearable
                :loading="loading"
                ref="autoComplete"
                :trigger-on-focus="true"
                style="width: 100%;"
            >
              <i
                  class="el-icon-edit el-input__icon"
                  slot="suffix"
                  @click="handleIconClick"
              >
              </i>
              <template slot-scope="{ item }">
                <div class="name">{{ item.value }}</div>
              </template>
            </el-autocomplete>
          </div>
          <div class="search-buttons">
            <el-button size="small" type="warning" @click="getGradeStudentCountByTeacher" icon="el-icon-search">
              搜尋
            </el-button>
            <el-button size="small" @click="resetSearch" icon="el-icon-refresh">
              重置
            </el-button>
          </div>
        </div>
      </div>

      <!-- 数据展示区 -->
      <div class="data-container">
        <!-- PC端表格（≥768px显示） -->
        <div class="pc-table">
          <el-table
              :data="tableData"
              style="width: 100%;"
              show-summary
              :summary-method="getTableSummary"
              border
              stripe
              size="small"
              :empty-text="tableData.length === 0 ? '暫無學生激活數據' : ''"
          >
            <el-table-column label="#" type="index" width="60"></el-table-column>
            <el-table-column prop="abbreviation" label="分校" align="center" min-width="100">
              <template slot-scope="{ row }">
                <span class="branch-name">{{ row.abbreviation || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="teacherUserNo" label="老師" align="center" min-width="100">
              <template slot-scope="{ row }">
                <span class="branch-name">{{ row.teacherUserNo || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="p1" label="P1" align="center" width="80">
              <template slot-scope="{ row }">
                <span>{{ row.p1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="p2" label="P2" align="center" width="80">
              <template slot-scope="{ row }">
                <span>{{ row.p2 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="p3" label="P3" align="center" width="80">
              <template slot-scope="{ row }">
                <span>{{ row.p3 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="p4" label="P4" align="center" width="80">
              <template slot-scope="{ row }">
                <span>{{ row.p4 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="p5" label="P5" align="center" width="80">
              <template slot-scope="{ row }">
                <span>{{ row.p5 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="p6" label="P6" align="center" width="80">
              <template slot-scope="{ row }">
                <span>{{ row.p6 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="totalCount" label="總計" align="center" width="100">
              <template slot-scope="{ row }">
                <span class="total-count">{{ row.totalCount }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 手机端卡片列表（<768px显示） -->
        <div class="mobile-cards">
          <div class="branch-card" v-for="(row, index) in tableData" :key="index">
            <!-- 卡片头部 -->
            <div class="card-header">
              <div class="branch-title">{{ row.abbreviation || '' }}</div>
              <div class="branch-title">{{ row.teacherUserNo || '' }}</div>
              <div class="branch-total">總計：<span class="total-num">{{ row.totalCount }}</span></div>
            </div>
            <!-- 年级数据 -->
            <div class="grade-grid">
              <div class="grade-item">
                <div class="grade-label">P1</div>
                <div class="grade-value">{{ row.p1 }}</div>
              </div>
              <div class="grade-item">
                <div class="grade-label">P2</div>
                <div class="grade-value">{{ row.p2 }}</div>
              </div>
              <div class="grade-item">
                <div class="grade-label">P3</div>
                <div class="grade-value">{{ row.p3 }}</div>
              </div>
              <div class="grade-item">
                <div class="grade-label">P4</div>
                <div class="grade-value">{{ row.p4 }}</div>
              </div>
              <div class="grade-item">
                <div class="grade-label">P5</div>
                <div class="grade-value">{{ row.p5 }}</div>
              </div>
              <div class="grade-item">
                <div class="grade-label">P6</div>
                <div class="grade-value">{{ row.p6 }}</div>
              </div>
            </div>
          </div>

          <!-- 移动端总计卡片 -->
          <div class="total-card" v-if="tableData.length > 0">
            <div class="total-header">整體統計</div>
            <div class="total-grid">
              <div class="total-grade-item">
                <div class="grade-label">P1</div>
                <div class="grade-value">{{ summaryData.p1 }}</div>
              </div>
              <div class="total-grade-item">
                <div class="grade-label">P2</div>
                <div class="grade-value">{{ summaryData.p2 }}</div>
              </div>
              <div class="total-grade-item">
                <div class="grade-label">P3</div>
                <div class="grade-value">{{ summaryData.p3 }}</div>
              </div>
              <div class="total-grade-item">
                <div class="grade-label">P4</div>
                <div class="grade-value">{{ summaryData.p4 }}</div>
              </div>
              <div class="total-grade-item">
                <div class="grade-label">P5</div>
                <div class="grade-value">{{ summaryData.p5 }}</div>
              </div>
              <div class="total-grade-item">
                <div class="grade-label">P6</div>
                <div class="grade-value">{{ summaryData.p6 }}</div>
              </div>
              <div class="total-all-item">
                <div class="grade-label">總計</div>
                <div class="grade-value total-all">{{ summaryData.totalAll }}</div>
              </div>
            </div>
          </div>

          <!-- 移动端空数据提示 -->
          <div class="empty-tip" v-if="tableData.length === 0">
            <i class="el-icon-empty"></i>
            <p>暫無學生激活數據</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getGradeStudentCountByTeacher } from "@/api/setting";
import { getTags } from "@/api/users";

export default {
  name: "TeacherStudentStatistic",
  data() {
    return {
      formLabelAlign: {
        branchSchoolId: null,
        tagsLike: null
      },
      filteredBranchSchools: [],
      tableData: [],
      summaryData: {
        p1: 0,
        p2: 0,
        p3: 0,
        p4: 0,
        p5: 0,
        p6: 0,
        totalAll: 0
      },
      // autocomplete 核心变量
      allTag: "",
      restaurants: [],
      loading: false
    };
  },
  created() {
    this.getGradeStudentCountByTeacher();
    this.filteredBranchSchools = this.$store.getters.branchSchools || [];
    this.getTags();
  },
  methods: {
    // 获取标签列表
    getTags() {
      this.loading = true;
      getTags().then((v) => {
        this.allTag = v.data || "";
        // 格式化标签为 autocomplete 要求的格式
        this.restaurants = this.allTag
            .split(",")
            .map(item => item.trim())
            .filter(item => item)
            .filter((item, index, self) => self.indexOf(item) === index)
            .map(item => ({ value: item }));
      }).catch(err => {
        console.error('获取标签失败：', err);
        this.restaurants = [];
      }).finally(() => {
        this.loading = false;
      });
    },
    // 编辑图标点击事件
    handleIconClick(ev) {
      console.log(ev);
      // 可选：点击图标清空输入框
      // this.formLabelAlign.tagsLike = "";
    },
    // 选中标签事件
    handleSelect(item) {
      console.log("选中标签：", item);
      this.formLabelAlign.tagsLike = item.value;
      // 可选：选中后自动搜索
      // this.getGradeStudentCountByTeacher();
    },
    // 筛选标签的方法
    createFilter(queryString) {
      return (item) => {
        return item.value.toLowerCase().indexOf(queryString.toLowerCase()) !== -1;
      };
    },
    // 联想查询方法
    querySearch(queryString, cb) {
      if (!this.restaurants) {
        cb([]);
        return;
      }
      const results = queryString
          ? this.restaurants.filter(this.createFilter(queryString))
          : this.restaurants;
      cb(results);
    },
    // 重置搜索条件
    resetSearch() {
      this.formLabelAlign.branchSchoolId = null;
      this.formLabelAlign.tagsLike = null;
      this.filteredBranchSchools = this.$store.getters.branchSchools || [];
      this.getGradeStudentCountByTeacher();
    },
    // 自定义筛选分校方法
    filterBranchSchool(val) {
      const branchSchools = this.$store.getters.branchSchools || [];
      if (!val) {
        this.filteredBranchSchools = branchSchools;
      } else {
        const searchText = val.toLowerCase().trim();
        this.filteredBranchSchools = branchSchools.filter(item => {
          const abbreviation = (item.abbreviation || "").toLowerCase();
          const nameZh = (item.nameZh || "").toLowerCase();
          const nameEn = (item.nameEn || "").toLowerCase();
          return abbreviation.includes(searchText) || nameZh.includes(searchText) || nameEn.includes(searchText);
        });
      }
    },
    // 获取统计数据
    getGradeStudentCountByTeacher() {
      getGradeStudentCountByTeacher(this.formLabelAlign).then((v) => {
        // 格式化数据，兼容字段名和数值类型
        this.tableData = (v.data || []).map(row => ({
          ...row,
          // 兼容后端下划线字段和驼峰字段
          teacherUserNo: row.teacher_user_no || row.teacherUserNo || '',
          abbreviation: row.abbreviation || '',
          // 确保数值类型正确
          p1: Number(row.p1) || 0,
          p2: Number(row.p2) || 0,
          p3: Number(row.p3) || 0,
          p4: Number(row.p4) || 0,
          p5: Number(row.p5) || 0,
          p6: Number(row.p6) || 0,
          totalCount: Number(row.totalCount) || Number(row.student_count) || 0
        }));
        // 更新汇总数据
        this.calculateSummary();
      }).catch(err => {
        console.error('获取数据失败：', err);
        this.tableData = [];
        this.calculateSummary();
      });
    },
    // 计算汇总数据（移动端）
    calculateSummary() {
      let totalP1 = 0, totalP2 = 0, totalP3 = 0, totalP4 = 0, totalP5 = 0, totalP6 = 0, totalAll = 0;
      this.tableData.forEach(row => {
        totalP1 += Number(row.p1) || 0;
        totalP2 += Number(row.p2) || 0;
        totalP3 += Number(row.p3) || 0;
        totalP4 += Number(row.p4) || 0;
        totalP5 += Number(row.p5) || 0;
        totalP6 += Number(row.p6) || 0;
        totalAll += Number(row.totalCount) || 0;
      });
      this.summaryData = {
        p1: totalP1,
        p2: totalP2,
        p3: totalP3,
        p4: totalP4,
        p5: totalP5,
        p6: totalP6,
        totalAll: totalAll
      };
    },
    // 表格汇总方法
    getTableSummary({ data }) {
      let totalP1 = 0, totalP2 = 0, totalP3 = 0, totalP4 = 0, totalP5 = 0, totalP6 = 0, totalAll = 0;
      data.forEach(row => {
        totalP1 += Number(row.p1) || 0;
        totalP2 += Number(row.p2) || 0;
        totalP3 += Number(row.p3) || 0;
        totalP4 += Number(row.p4) || 0;
        totalP5 += Number(row.p5) || 0;
        totalP6 += Number(row.p6) || 0;
        totalAll += Number(row.totalCount) || 0;
      });
      // 确保返回数组长度与表格列数一致
      return [
        '總計',        // 序号列
        '全部',        // 分校列
        '全部',        // 老师列
        totalP1,       // P1列
        totalP2,       // P2列
        totalP3,       // P3列
        totalP4,       // P4列
        totalP5,       // P5列
        totalP6,       // P6列
        totalAll       // 总计列
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
/* 基础样式 */
.page {
  padding: 16px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

/* 统一风格页头 */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e4e7ed;

  .header-left {
    .page-title {
      font-size: 22px;
      font-weight: 600;
      color: #B62D2E;
      margin: 0 0 4px 0;
    }
    .page-subtitle {
      font-size: 14px;
      color: #6c757d;
      margin: 0;
    }
  }

  .header-right {
    display: flex;
    gap: 8px;
  }
}

/* 布局容器 */
.layout {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

/* 搜索卡片样式 */
.search-card {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 6px;
  margin-bottom: 20px;

  .search-row {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    align-items: center;

    .search-item {
      flex: 1;
      min-width: 200px;
    }

    .search-buttons {
      display: flex;
      gap: 8px;
      flex-shrink: 0;
    }
  }
}

/* 数据容器样式 */
.data-container {
  width: 100%;

  /* PC端表格样式 */
  .pc-table {
    ::v-deep {
      .el-table {
        --el-table-header-text-color: #4e5969;
        --el-table-row-hover-bg-color: #f8f9fa;
      }

      .el-table th {
        background: #f8f9fa;
        font-weight: 600;
      }

      /* 汇总行样式 */
      .el-table__footer-wrapper .el-table-cell {
        font-weight: bold;
        background-color: #e9ecef;
        color: #166ea5;
      }

      .total-count {
        font-weight: 600;
        color: #166ea5;
      }

      .branch-name {
        font-weight: 500;
      }
    }
  }

  /* 手机端卡片样式 */
  .mobile-cards {
    display: none;
    flex-direction: column;
    gap: 16px;

    /* 分校卡片 */
    .branch-card {
      background: #f8f9fa;
      border-radius: 8px;
      padding: 16px;
      border: 1px solid #e9ecef;

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
        padding-bottom: 8px;
        border-bottom: 1px solid #dee2e6;

        .branch-title {
          font-size: 16px;
          font-weight: 600;
          color: #1f2937;
        }

        .branch-total {
          font-size: 14px;
          color: #166ea5;
          .total-num {
            font-weight: 600;
          }
        }
      }

      .grade-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 8px;

        .grade-item {
          background: #fff;
          border-radius: 4px;
          padding: 8px;
          text-align: center;

          .grade-label {
            font-size: 12px;
            color: #6c757d;
            margin-bottom: 4px;
          }

          .grade-value {
            font-size: 16px;
            font-weight: 600;
            color: #1f2937;
          }
        }
      }
    }

    /* 总计卡片 */
    .total-card {
      background: linear-gradient(135deg, #e8f4f8 0%, #f0f8fb 100%);
      border-radius: 8px;
      padding: 16px;
      border: 1px solid #166ea5;

      .total-header {
        font-size: 16px;
        font-weight: 600;
        color: #166ea5;
        margin-bottom: 12px;
        text-align: center;
      }

      .total-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 8px;

        .total-grade-item {
          background: #fff;
          border-radius: 4px;
          padding: 8px;
          text-align: center;

          .grade-label {
            font-size: 12px;
            color: #6c757d;
            margin-bottom: 4px;
          }

          .grade-value {
            font-size: 16px;
            font-weight: 600;
            color: #1f2937;
          }
        }

        .total-all-item {
          grid-column: span 3;
          background: #166ea5;
          border-radius: 4px;
          padding: 8px;
          text-align: center;

          .grade-label {
            font-size: 12px;
            color: #fff;
            margin-bottom: 4px;
          }

          .grade-value {
            font-size: 18px;
            font-weight: 600;
            color: #fff;
          }
        }
      }
    }

    /* 空数据提示 */
    .empty-tip {
      text-align: center;
      padding: 40px 20px;
      color: #999;

      i {
        font-size: 48px;
        margin-bottom: 16px;
        display: block;
        color: #ced4da;
      }

      p {
        font-size: 16px;
        margin: 0;
      }
    }
  }
}

/* 响应式适配 */
@media (max-width: 768px) {
  .page {
    padding: 8px;
  }

  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding-bottom: 12px;
  }

  .layout {
    padding: 16px;
  }

  /* 搜索区适配 */
  .search-card .search-row {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .search-card .search-row .search-buttons {
    justify-content: flex-end;
  }

  /* 隐藏PC表格，显示手机卡片 */
  .data-container .pc-table {
    display: none;
  }

  .data-container .mobile-cards {
    display: flex;
  }
}

/* 适配平板屏幕 */
@media (min-width: 769px) and (max-width: 1024px) {
  .search-card .search-row .search-item {
    min-width: 160px;
  }
}

/* 自动完成组件样式 */
.my-autocomplete {
  li {
    line-height: normal;
    padding: 7px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  .empty-tip {
    padding: 10px;
    text-align: center;
    color: #999;
    font-size: 12px;
  }
}
</style>